export default __webpack_public_path__ + "static/media/Metrô Fill.4e35ec26.svg";